const recipeListMapping = (data, pageType) => {

    const mappedData = {};

    mappedData.recipes = data.map((item) => {
      let images = item?.relationships?.field_components?.data.find(component => {
        return component.type === "paragraph--article_images"
      })

      let langcode = item.attributes.path?.langcode == 'en' ? '' : '/' + item.attributes.path?.langcode;

      return {
        imageSrc: images?.field_thumbnail_img[0]?.url,
        imageAlt: images?.field_thumbnail_img[0]?.alt,
        title: item.attributes.title,
        cta: item?.attributes ? {
          title: (pageType === 'promotions') ? "See the promotion" : "See the recipe" ,
          alt: (pageType === 'promotions') ? "CTA See the promotion" : "CTA See the recipe",
          href: langcode + item.attributes.path?.alias || '/'
        } : {}
      };
    });

    return mappedData;
};


export default recipeListMapping;
